import { render, staticRenderFns } from "./CardSpinner.vue?vue&type=template&id=0cd86835"
import script from "./CardSpinner.vue?vue&type=script&lang=js"
export * from "./CardSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports